export default __webpack_public_path__ + "static/media/qboy.626c786d.png";